import { useEffect, useState } from 'react';
import { ArrowRight, Newspaper } from 'lucide-react';
import { classifiedsFreeNow, FREE_CLASSIFIEDS_LABEL } from '@generated/components/classifiedPromo';

/** Front-page "free classifieds" banner; opens the classified ad form. Hides itself when the offer ends. */
export function ClassifiedBanner({ onOpen }: { onOpen: () => void }) {
  const [show, setShow] = useState(true);
  useEffect(() => { setShow(classifiedsFreeNow()); }, []);
  if (!show) return null;
  return (
    <button type="button" onClick={onOpen} aria-label="Place a free classified ad" className="group mx-auto mt-6 block w-full max-w-6xl px-4 text-left">
      <div className="flex flex-col gap-4 border-2 border-foreground bg-[hsl(var(--banner-red))] p-5 text-primary-foreground shadow-[6px_6px_0_hsl(var(--muted-foreground)/0.35)] transition-transform group-hover:-translate-y-0.5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
        <div className="flex items-start gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center border-2 border-foreground bg-card text-foreground"><Newspaper className="h-8 w-8" /></div>
          <div className="min-w-0">
            <div className="text-[11px] font-bold uppercase tracking-[0.2em]">Our thanks to our readers</div>
            <div className="font-[family-name:var(--font-heading)] text-2xl font-black leading-tight tracking-tight sm:text-3xl"><span className="uppercase">Free classifieds</span> in the Star-Revue</div>
            <div className="text-sm font-black uppercase tracking-wide">Now {FREE_CLASSIFIEDS_LABEL}</div>
            <p className="mt-1 text-sm font-medium">Selling, hiring, renting, or found a cat? Place your ad in the Red Hook or Village Star-Revue at no charge.</p>
          </div>
        </div>
        <span className="inline-flex min-h-12 shrink-0 items-center justify-center gap-2 border-2 border-foreground bg-foreground px-5 text-base font-bold text-background">
          Place my free ad <ArrowRight className="h-5 w-5" strokeWidth={3} />
        </span>
      </div>
    </button>
  );
}
